<template>
    <div id="auth">
        <div class="login-section">
            <form class="form" @submit.prevent="sendForm" autocomplete="off">
                <div class="form-group">
                    <label>Email</label>
                    <input disabled data-cy="email" type="email" v-model="form.email" />
                    <has-error data-cy="email_error" :form="form" field="email"></has-error>
                </div>

                <div class="form-group">
                    <label>Reset Pin</label>
                    <input
                        data-cy="password_reset_token"
                        type="text"
                        maxlength="6"
                        v-model="form.password_reset_token"
                        autocomplete="off"
                        style="text-align: center; letter-spacing: 10px; font-size: 20px"
                    />
                    <has-error
                        data-cy="password_reset_token_error"
                        :form="form"
                        field="password_reset_token"
                    ></has-error>
                </div>

                <div class="form-group">
                    <label>Choose a new password</label>
                    <input
                        data-cy="password"
                        type="password"
                        v-model="form.password"
                        autocomplete="new-password"
                    />
                    <has-error data-cy="password_error" :form="form" field="password"></has-error>
                </div>

                <div class="form-group">
                    <button
                        :disabled="form.busy"
                        data-cy="submit"
                        type="submit"
                        name="button"
                        class="button dark"
                    >
                        {{ form.busy ? "Please wait" : "Reset Password" }}
                    </button>
                </div>
            </form>
            <div class="login-form-nav-links">
                <router-link to="login">Back to home</router-link>
            </div>
        </div>
    </div>
</template>

<script>
import Cookie from "js-cookie";
import { Form, HasError } from "vform";
export default {
    name: "reset",
    components: { HasError },
    created() {
        if (!this.$route.query.email) {
            this.$router.push("/404");
        }
        this.form.email = this.$route.query.email;
        this.form.password_reset_token = "";
    },
    data() {
        return {
            form: new Form({
                email: "",
                password: "",
            }),
        };
    },
    methods: {
        sendForm() {
            this.form
                .post("/reset")
                .then((response) => {
                    Cookie.set(process.env.VUE_APP_AUTH_COOKIE_NAME, response.data.api_token);
                    this.$router.push({ name: "Home" });
                    this.$store.state.user = response.data;
                })
                .catch((error) => {
                    if (error.response.status == 404) {
                        alert(
                            "We can't reset your password. Please check your email and reset token is correct.",
                        );
                    }
                });
        },
    },
};
</script>

<style lang="less">
.form {
    .form-group {
        label {
            display: block;
        }
        input[type="text"],
        input[type="email"],
        input[type="password"] {
            width: 100%;
        }
    }
}
</style>
